export type ServiceMessage = {
    method: string;
    args: any;
}
export type Service = (message: ServiceMessage) => any;


export class ServiceManager {
    services: Map<string, Service>;

    constructor() {
        this.services = new Map<string, Service>();
    }

    register(id: string, service: Service) {
        this.services.set(id, service);
    }

    call(target: string, message: ServiceMessage): any {
        const service = this.services.get(target);
        if (service === null || service === undefined) {
            return new Error(`unknown service ${target}`);
        }
        return service(message);
    }
}
